

import { sanitizeFilename } from "../sanitizeFilename";

export function projectBuilderToPptDocument(
result)
{
  const slides = [
  {
    kind: "title",
    title: result.pageTitle,
    subtitle: `${result.curriculumLabel} · ${result.projectTypeLabel}`
  },
  {
    kind: "section",
    title: "Project context",
    body: [result.projectTypeLabel, result.complexityLabel, result.modeLabel].
    filter(Boolean).
    join(" · ")
  },
  {
    kind: "bullets",
    title: "Purpose",
    bullets: [result.studentCopy.purpose].filter(Boolean)
  },
  ...result.studentCopy.milestones.map((milestone) => ({
    kind: "bullets",
    title: `${milestone.step}. ${milestone.title} ${milestone.dayLabel}`,
    bullets: [milestone.body, `Deliverable: ${milestone.deliverable}`].filter(Boolean)
  })),
  {
    kind: "bullets",
    title: "Implementation guidance",
    bullets: result.studentCopy.implementationGuidance.map(
      (step) => `${step.label} — ${step.title}: ${step.body}`
    )
  },
  ...(result.supportingElements.length ?
  [
  {
    kind: "bullets",
    title: "Supporting elements",
    bullets: result.supportingElements.map(
      (item) => `${item.label} · ${item.title} — ${item.body}`
    )
  }] :

  []),
  ...(result.quickCheckQuestions.length ?
  [
  {
    kind: "bullets",
    title: "Quick check / validation",
    bullets: result.quickCheckQuestions.map((q) => q.text)
  }] :

  []),
  ...(result.optionalTip ?
  [
  {
    kind: "section",
    title: "Teacher tip",
    body: result.optionalTip
  }] :

  [])];


  return {
    filename: sanitizeFilename(`${result.topicLabel} project-plan`, "project-builder"),
    title: result.pageTitle,
    subject: result.curriculumLabel,
    author: "Tema Project Builder",
    slides
  };
}